import { DEFAULT_APPS_FILTERS } from './constants';

const defaultSettings = {
  pending: true,
  loaded: false,
  error: false,
};

export const makeDefaultState = ({ filters, appsFilters }) => ({
  filters: { ...filters },
  general: {
    data: null,
    settings: { ...defaultSettings },
  },
  totals: {
    data: null,
    settings: { ...defaultSettings },
  },
  apps: {
    data: [],
    totals: {},
    totalCount: 0,
    settings: { ...defaultSettings },
    filters: {
      ...DEFAULT_APPS_FILTERS,
      ...(appsFilters.metric ? { metric: appsFilters.metric } : {}),
      ...(appsFilters.order ? { order: appsFilters.order } : {}),
      offset: appsFilters.offset || 0,
    },
  },
  monetization: {
    data: null,
    settings: { ...defaultSettings },
  },
  timeSeries: {
    data: null,
    settings: { ...defaultSettings },
  },
  sdks: {
    data: [],
    settings: { ...defaultSettings },
  },
  companyInfo: {
    data: null,
    settings: { ...defaultSettings },
  },
});
